import RSS_LOGO from "./media/sponsors/RSS.png";
import FACULTY_OF_ENG from "./media/sponsors/Facutlyofeng.png";
import RECESS from "./media/sponsors/RECESS.png";
import RUFOS from "./media/sponsors/RUFOS.png";
import FDM from "./media/sponsors/FDM.png";
import Sublime from "./media/sponsors/Sublime.png";
import ONE_PASS from "./media/sponsors/1P.png";
import BALSAMIQ from "./media/sponsors/balsamiq.png";
import WOLFRAM from "./media/sponsors/Wolfram.png";
import EF from "./media/sponsors/EF.png";
import IX from "./media/sponsors/iXperience.png";
import LL from "./media/sponsors/LL.png";
import IBZ from "./media/sponsors/IBZ.png";
import DCL from "./media/sponsors/DCL.png";
import Openscreen from "./media/sponsors/Openscreen.png";
import PROTO from "./media/sponsors/proto.png";
const sponsors = [
  {
    name: "RSS (Ryerson Science Society)",
    link: "https://www.rssonline.ca/",
    logo: RSS_LOGO,
    size: "XL",
  },
  {
    name: "Openscreen",
    link: "https://www.openscreen.com/",
    logo: Openscreen,
    size: "XL",
  },
  {
    name: "Ryerson Department of Electrical, Computer, and Biomedical Engineering",
    link: "https://www.ee.ryerson.ca/",
    logo: FACULTY_OF_ENG,
    size: "XL",
  },
  {
    name: "Distributed Compute Labs",
    link: "https://distributed.computer/",
    logo: DCL,
    size: "L",
  },
  {
    name: "iXperience",
    link: "https://ixperience.co/",
    logo: IX,
    size: "L",
  },
  {
    name: "Ryerson Faculty of Science",
    link: "https://www.ryerson.ca/science/",
    logo: RUFOS,
    size: "L",
  },
  {
    name: "RECESS (Ryerson Electrical and Computer Engineering Student Society)",
    link: "https://www.ee.ryerson.ca/~recess/",
    logo: RECESS,
    size: "M",
  },
  {
    name: "FDM",
    link: "https://www.fdmgroup.com/",
    logo: FDM,
    size: "M",
  },
  {
    name: "IBZ",
    link: "https://www.ryerson.ca/innovation-boost-zone/",
    logo: IBZ,
    size: "M",
  },
  {
    name: "Entrepreneur First",
    link: "https://www.joinef.com/",
    logo: EF,
    size: "M",
  },
  {
    name: "Leading Learners",
    link: "https://www.leading-learners.com/",
    logo: LL,
    size: "M",
  },
  {
    name: "Wolfram",
    link: "https://www.wolfram.com/",
    logo: WOLFRAM,
    size: "M",
  },
  {
    name: "Balsamiq",
    link: "https://balsamiq.com/",
    logo: BALSAMIQ,
    size: "S",
  },
  {
    name: "1Password",
    link: "https://1password.com/",
    logo: ONE_PASS,
    size: "S",
  },
  {
    name: "Sublime",
    link: "https://www.sublimetext.com/",
    logo: Sublime,
    size: "S",
  },
  { name: "Proto.io", link: "https://proto.io/", logo: PROTO, size: "S" },
];

export default sponsors;
